import type EnType from '../en-US/project';

export default {
  'projectDetail.label.lookDetailButton': '表示する',
} satisfies typeof EnType;
